webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(26);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vue = __webpack_require__(90);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(6);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _App = __webpack_require__(76);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _cover = __webpack_require__(77);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	var _q = __webpack_require__(78);
	
	var _q2 = _interopRequireDefault(_q);
	
	var _q3 = __webpack_require__(80);
	
	var _q4 = _interopRequireDefault(_q3);
	
	var _q5 = __webpack_require__(81);
	
	var _q6 = _interopRequireDefault(_q5);
	
	var _q7 = __webpack_require__(82);
	
	var _q8 = _interopRequireDefault(_q7);
	
	var _q9 = __webpack_require__(83);
	
	var _q10 = _interopRequireDefault(_q9);
	
	var _q11 = __webpack_require__(84);
	
	var _q12 = _interopRequireDefault(_q11);
	
	var _q13 = __webpack_require__(85);
	
	var _q14 = _interopRequireDefault(_q13);
	
	var _q15 = __webpack_require__(86);
	
	var _q16 = _interopRequireDefault(_q15);
	
	var _q17 = __webpack_require__(87);
	
	var _q18 = _interopRequireDefault(_q17);
	
	var _q19 = __webpack_require__(79);
	
	var _q20 = _interopRequireDefault(_q19);
	
	var _result = __webpack_require__(88);
	
	var _result2 = _interopRequireDefault(_result);
	
	var _vueResource = __webpack_require__(89);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	_App2.default.components = {
	  cover: _cover2.default,
	  q1: _q2.default,
	  q2: _q4.default,
	  q3: _q6.default,
	  q4: _q8.default,
	  q5: _q10.default,
	  q6: _q12.default,
	  q7: _q14.default,
	  q8: _q16.default,
	  q9: _q18.default,
	  q10: _q20.default,
	  result: _result2.default
	};
	var answerObj = { testNo: 1 };
	
	new _vue2.default({
	  el: 'body',
	  data: function data() {
	    return {
	      currentView: 'cover',
	      step: 0,
	      testNo: 1
	    };
	  },
	
	  components: { App: _App2.default },
	  events: {
	    changeView: function changeView(view, score, answer) {
	      (0, _assign2.default)(answerObj, answer);
	      _store2.default.score += score;
	      this.step += 1;
	      if (view === 'result') {
	        this.$http.jsonp('http://m.creditcard.com.cn/apply/action/applyForCreditCardEvaluate.html', { params: answerObj });
	        var url = '';
	        switch (!0) {
	          case _store2.default.score < 25:
	            url = 'http://sites.wacai.com/973/index.html';
	            break;
	          case _store2.default.score < 55:
	            url = 'http://sites.wacai.com/974/index.html';
	            break;
	          case _store2.default.score < 65:
	            url = 'http://sites.wacai.com/975/index.html';
	            break;
	          case _store2.default.score < 75:
	            url = 'http://sites.wacai.com/976/index.html';
	            break;
	          case _store2.default.score < 85:
	            url = 'http://sites.wacai.com/977/index.html';
	            break;
	          case _store2.default.score < 95:
	            url = 'http://sites.wacai.com/978/index.html';
	            break;
	          case _store2.default.score > 95:
	            url = 'http://sites.wacai.com/979/index.html';
	            break;
	        }
	        window.location.href = url;
	        return false;
	      }
	      this.currentView = view;
	    },
	    redo: function redo() {
	      _store2.default.score = 0;
	      this.step = 0;
	      this.testNo += 1;
	      answerObj = { testNo: this.testNo };
	      this.currentView = 'cover';
	    }
	  }
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(60)
	__vue_script__ = __webpack_require__(24)
	__vue_template__ = __webpack_require__(75)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  score: 0
	};

/***/ },
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['currentView', 'step'],
	  computed: {
	    showStep: function showStep() {
	      return this.currentView !== 'result' && this.currentView !== 'cover';
	    },
	    progress: function progress() {
	      return this.step / 10 * 100;
	    }
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    goTest: function goTest() {
	      this.$dispatch('changeView', 'q1', 0);
	    }
	  }
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _radioList = __webpack_require__(1);
	
	var _radioList2 = _interopRequireDefault(_radioList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { RadioList: _radioList2.default },
	  events: {
	    goNext: function goNext(score, answer) {
	      this.$dispatch('changeView', 'q2', score, answer);
	    }
	  },
	  data: function data() {
	    return {
	      question: {
	        title: '年龄',
	        qId: 'q1',
	        options: [{
	          text: '22周岁以下',
	          score: -5,
	          aId: 'a1'
	        }, {
	          text: '22-23周岁',
	          score: -1,
	          aId: 'a2'
	        }, {
	          text: '24-26周岁',
	          score: 3,
	          aId: 'a2'
	        }, {
	          text: '27-30周岁',
	          score: 7,
	          aId: 'a3'
	        }, {
	          text: '31-40周岁',
	          score: 10,
	          aId: 'a4'
	        }, {
	          text: '41-50周岁',
	          score: 14,
	          aId: 'a5'
	        }, {
	          text: '50周岁以上',
	          score: 12,
	          aId: 'a6'
	        }]
	      }
	    };
	  }
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _radioList = __webpack_require__(1);
	
	var _radioList2 = _interopRequireDefault(_radioList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { RadioList: _radioList2.default },
	  events: {
	    goNext: function goNext(score, answer) {
	      this.$dispatch('changeView', 'result', score, answer);
	    }
	  },
	  data: function data() {
	    return {
	      complete: true,
	      question: {
	        title: '您是否已有信用卡',
	        qId: 'q9',
	        options: [{
	          text: '没有',
	          score: 0,
	          aId: 'a1'
	        }, {
	          text: '1张',
	          score: 5,
	          aId: 'a2'
	        }, {
	          text: '2张',
	          score: 8,
	          aId: 'a3'
	        }, {
	          text: '3张',
	          score: 10,
	          aId: 'a4'
	        }, {
	          text: '4张',
	          score: 5,
	          aId: 'a5'
	        }, {
	          text: '4张以上',
	          score: -5,
	          aId: 'a6'
	        }]
	      }
	    };
	  }
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _radioList = __webpack_require__(1);
	
	var _radioList2 = _interopRequireDefault(_radioList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { RadioList: _radioList2.default },
	  events: {
	    goNext: function goNext(score, answer) {
	      this.$dispatch('changeView', 'q3', score, answer);
	    }
	  },
	  data: function data() {
	    return {
	      question: {
	        title: '学历',
	        qId: 'q2',
	        options: [{
	          text: '中专\\高中以下',
	          score: 4,
	          aId: 'a1'
	        }, {
	          text: '大专',
	          score: 6,
	          aId: 'a2'
	        }, {
	          text: '本科',
	          score: 8,
	          aId: 'a3'
	        }, {
	          text: '硕士及以上',
	          score: 9,
	          aId: 'a4'
	        }]
	      }
	    };
	  }
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _radioList = __webpack_require__(1);
	
	var _radioList2 = _interopRequireDefault(_radioList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { RadioList: _radioList2.default },
	  events: {
	    goNext: function goNext(score, answer) {
	      this.$dispatch('changeView', 'q4', score, answer);
	    }
	  },
	  data: function data() {
	    return {
	      question: {
	        title: '年收入',
	        qId: 'q3',
	        options: [{
	          text: '低于3万',
	          score: 2,
	          aId: 'a1'
	        }, {
	          text: '3.0万-4.5万',
	          score: 5,
	          aId: 'a2'
	        }, {
	          text: '4.5万-5.5万',
	          score: 10,
	          aId: 'a3'
	        }, {
	          text: '5.5万-7.5万',
	          score: 16,
	          aId: 'a4'
	        }, {
	          text: '7.5万-9.5万',
	          score: 21,
	          aId: 'a5'
	        }, {
	          text: '10万以上',
	          score: 24,
	          aId: 'a6'
	        }]
	      }
	    };
	  }
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _radioList = __webpack_require__(1);
	
	var _radioList2 = _interopRequireDefault(_radioList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { RadioList: _radioList2.default },
	  events: {
	    goNext: function goNext(score, answer) {
	      this.$dispatch('changeView', 'q5', score, answer);
	    }
	  },
	  data: function data() {
	    return {
	      question: {
	        title: '您的住房情况',
	        qId: 'q4',
	        options: [{
	          text: '短期租房',
	          score: 0,
	          aId: 'a1'
	        }, {
	          text: '长期租房',
	          score: 2,
	          aId: 'a2'
	        }, {
	          text: '自有房产价值低于100万',
	          score: 18,
	          aId: 'a3'
	        }, {
	          text: '自有房产价值大于100万',
	          score: 24,
	          aId: 'a4'
	        }, {
	          text: '其他',
	          score: -2,
	          aId: 'a5'
	        }]
	      }
	    };
	  }
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _radioList = __webpack_require__(1);
	
	var _radioList2 = _interopRequireDefault(_radioList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { RadioList: _radioList2.default },
	  events: {
	    goNext: function goNext(score, answer) {
	      this.$dispatch('changeView', 'q6', score, answer);
	    }
	  },
	  data: function data() {
	    return {
	      question: {
	        title: '您在当前公司的工作时长',
	        qId: 'q5',
	        options: [{
	          text: '少于半年',
	          score: 0,
	          aId: 'a1'
	        }, {
	          text: '半年-一年',
	          score: 3,
	          aId: 'a2'
	        }, {
	          text: '一年-三年',
	          score: 10,
	          aId: 'a3'
	        }, {
	          text: '三年-五年',
	          score: 16,
	          aId: 'a4'
	        }, {
	          text: '五年以上',
	          score: 21,
	          aId: 'a5'
	        }]
	      }
	    };
	  }
	};

/***/ },
/* 20 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    select: function select(option) {
	      var index = this.selectedItems.indexOf(option);
	      index > -1 ? this.selectedItems.splice(index, 1) : this.selectedItems.push(option);
	    },
	    goNext: function goNext() {
	      var score = 0;
	      var answerLength = this.selectedItems.length;
	      if (answerLength === 0) {
	        return false;
	      }
	      var answers = [];
	      this.selectedItems.forEach(function (option, index) {
	        score += answerLength > 1 && option.score < 0 ? 0 : option.score;
	        answers.push(option.aId);
	      });
	      var answerObj = {};
	      answerObj[this.question.qId] = answers.join(',');
	      this.$dispatch('changeView', 'q7', score, answerObj);
	      this.selectedItems = [];
	    }
	  },
	  data: function data() {
	    return {
	      question: {
	        title: '您可以提供以下哪些联系方式',
	        qId: 'q6',
	        options: [{
	          text: '个人手机',
	          score: -2,
	          aId: 'a1'
	        }, {
	          text: '家庭固话',
	          score: 2,
	          aId: 'a2'
	        }, {
	          text: '单位固话',
	          score: 5,
	          aId: 'a3'
	        }]
	      },
	      selectedItems: []
	    };
	  }
	};

/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    select: function select(option) {
	      var special = this.question.options[4];
	      var index = this.selectedItems.indexOf(option);
	      if (index > -1) {
	        this.selectedItems.splice(index, 1);
	      } else {
	        if (this.selectedItems.indexOf(special) > -1) {
	          this.selectedItems = [];
	        } else {
	          option === special && (this.selectedItems = []);
	        }
	        this.selectedItems.push(option);
	      }
	    },
	    goNext: function goNext() {
	      var score = 0;
	      var answerLength = this.selectedItems.length;
	      if (answerLength === 0) {
	        return false;
	      }
	      var answers = [];
	      this.selectedItems.forEach(function (option, index) {
	        score += answerLength > 1 && option.score < 0 ? 0 : option.score;
	        answers.push(option.aId);
	      });
	      var answerObj = {};
	      answerObj[this.question.qId] = answers.join(',');
	      this.$dispatch('changeView', 'q9', score, answerObj);
	      this.selectedItems = [];
	    }
	  },
	  data: function data() {
	    return {
	      question: {
	        title: '信贷记录',
	        qId: 'q7',
	        options: [{
	          text: '有3天内逾期记录',
	          score: -6,
	          aId: 'a1'
	        }, {
	          text: '有担保记录',
	          score: -4,
	          aId: 'a2'
	        }, {
	          text: '有供车记录',
	          score: 6,
	          aId: 'a3'
	        }, {
	          text: '有供房记录',
	          score: 10,
	          aId: 'a4'
	        }, {
	          text: '无信贷记录',
	          score: -2,
	          aId: 'a5'
	        }]
	      },
	      selectedItems: []
	    };
	  }
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _radioList = __webpack_require__(1);
	
	var _radioList2 = _interopRequireDefault(_radioList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { RadioList: _radioList2.default },
	  events: {
	    goNext: function goNext(score, answer) {
	      this.$dispatch('changeView', 'q9', score, answer);
	    }
	  },
	  data: function data() {
	    return {
	      question: {
	        title: '你在银行的存款数',
	        qId: 'q8',
	        options: [{
	          text: '5万以下',
	          score: 0,
	          aId: 'a1'
	        }, {
	          text: '5-10万',
	          score: 5,
	          aId: 'a2'
	        }, {
	          text: '10-20万',
	          score: 8,
	          aId: 'a3'
	        }, {
	          text: '20-50万',
	          score: 10,
	          aId: 'a4'
	        }, {
	          text: '50-100万',
	          score: 12,
	          aId: 'a5'
	        }, {
	          text: '100万以上',
	          score: 20,
	          aId: 'a6'
	        }]
	      }
	    };
	  }
	};

/***/ },
/* 23 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    select: function select(option) {
	      var special = this.question.options[4];
	      var index = this.selectedItems.indexOf(option);
	      if (index > -1) {
	        this.selectedItems.splice(index, 1);
	      } else {
	        if (this.selectedItems.indexOf(special) > -1) {
	          this.selectedItems = [];
	        } else {
	          option === special && (this.selectedItems = []);
	        }
	        this.selectedItems.push(option);
	      }
	    },
	    goNext: function goNext() {
	      var score = 0;
	      var answerLength = this.selectedItems.length;
	      if (answerLength === 0) {
	        return false;
	      }
	      var answers = [];
	      this.selectedItems.forEach(function (option, index) {
	        score += answerLength > 1 && option.score < 0 ? 0 : option.score;
	        answers.push(option.aId);
	      });
	      var answerObj = {};
	      answerObj[this.question.qId] = answers.join(',');
	      this.$dispatch('changeView', 'q10', score, answerObj);
	      this.selectedItems = [];
	    }
	  },
	  data: function data() {
	    return {
	      question: {
	        title: '其他资料',
	        qId: 'q8',
	        options: [{
	          text: '拥有银行储蓄账户',
	          score: 0,
	          aId: 'a1'
	        }, {
	          text: '拥有代发工资账户',
	          score: 8,
	          aId: 'a2'
	        }, {
	          text: '在银行有连续6个月以上结息记录',
	          score: 12,
	          aId: 'a3'
	        }, {
	          text: '在银行有存定期一年以上记录',
	          score: 24,
	          aId: 'a4'
	        }, {
	          text: '无法提供',
	          score: -8,
	          aId: 'a5'
	        }]
	      },
	      selectedItems: []
	    };
	  }
	};

/***/ },
/* 24 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['question', 'complete'],
	  data: function data() {
	    return {
	      score: 0,
	      selectedItem: {},
	      btnDisable: true
	    };
	  },
	
	  methods: {
	    select: function select(item, e) {
	      this.score = item.score;
	      this.selectedItem = item;
	      this.btnDisable = false;
	    },
	    goNext: function goNext() {
	      if (this.btnDisable) {
	        return false;
	      }
	      var t = {};
	      t[this.question.qId] = this.selectedItem.aId;
	      this.$dispatch('goNext', this.score, t);
	      this.btnDisable = true;
	    }
	  }
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(6);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      score: _store2.default.score
	    };
	  },
	
	  computed: {
	    result: function result() {
	      var cards = {
	        bank0: {
	          quota: null,
	          cardName: '农行乐卡',
	          cardImgClass: 'card-img0',
	          cardDesc: '申请率高<br/>首年免年费，满5次免次年年费<br/>支持小额快速支付功能，挥卡可付',
	          redirect: 'http://lxzl.abchina.com/cards/ApplyStep1?id=47&channel_code=0130'
	        },
	        bank1: {
	          quota: '0.5-1',
	          cardName: '农行金穗QQ联名IC信用卡',
	          cardImgClass: 'card-img1',
	          cardDesc: '终身免年费<br/>同城本行范围内提取超额还款免取现手续费<br/>支持带电子现金应用',
	          redirect: 'http://lxzl.abchina.com/cards/ApplyStep1?id=19&channel_code=0130'
	        },
	        bank2: {
	          quota: '1-2',
	          cardName: '光大福ic信用卡',
	          cardImgClass: 'card-img2',
	          cardDesc: '首年免年费<br/>首刷赠10万积分<br/>屈臣氏满200减50',
	          redirect: 'https://xyk.cebbank.com/cebmms/apply/fz/card-apply-index.htm?req_card_id=1001&pro_code=FHTG237746SJ01HZWC'
	        },
	        bank3: {
	          quota: '2-3',
	          cardName: '中信淘宝网联名卡（v卡）金卡',
	          cardImgClass: 'card-img3',
	          cardDesc: '剁手族必备，网购超划算<br/>新客户享30元支付宝红包<br/>4小时1000元航班延误险',
	          redirect: 'https://creditcard.ecitic.com/citiccard/newwap/pages/AppCreditCard/applayCard-process.html?sid=SJXYKZC&pid=CS0150'
	        },
	        bank4: {
	          quota: '3-4',
	          cardName: '平安携程商旅金卡',
	          cardImgClass: 'card-img4',
	          cardDesc: '同享携程金牌会员<br/>赠高达260万海陆空全方位意外保障<br/>赠全天候国内紧急救援',
	          redirect: 'https://c.pingan.com/apply/mobile/apply/index.html?scc=920000135&ccp=5a1a2a3a4a8a9a10a11a12a13&show=0'
	        },
	        bank5: {
	          quota: '4-5',
	          cardName: '中信i白金信用卡',
	          cardImgClass: 'card-img5',
	          cardDesc: '免年费白金卡<br/>IMAX五折观影<br/>网络交易计积分',
	          redirect: 'https://creditcard.ecitic.com/citiccard/newwap/pages/AppCreditCard/applayCard-process.html?sid=SJXYKZC&pid=CS0083'
	        },
	        bank6: {
	          quota: '6万以上',
	          cardName: '平安保险金卡',
	          cardImgClass: 'card-img6',
	          cardDesc: '平安保险值得信赖<br/>每年获赠高达130万全方位保障<br/>每年获赠国内急难救援服务',
	          redirect: 'https://c.pingan.com/apply/mobile/apply/index.html?scc=920000135&ccp=4a1a2a3a5a8a9a10a11a12a13&show=0'
	        }
	      };
	      switch (!0) {
	        case this.score < 25:
	          return cards.bank0;
	        case this.score < 55:
	          return cards.bank1;
	        case this.score < 65:
	          return cards.bank2;
	        case this.score < 75:
	          return cards.bank3;
	        case this.score < 85:
	          return cards.bank4;
	        case this.score < 95:
	          return cards.bank5;
	        case this.score > 95:
	          return cards.bank6;
	      }
	    }
	  },
	  methods: {
	    redo: function redo() {
	      this.$dispatch('redo');
	    }
	  }
	};

/***/ },
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 55 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 56 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 57 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 58 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 59 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 60 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/cover_card.1c6c0a1.png";

/***/ },
/* 62 */
/***/ function(module, exports) {

	module.exports = "<div id=app> <div class=progress-bg v-if=showStep> <div class=progress :style=\"{ width : progress + '%'}\"> </div> </div> <components :is=currentView transition=slid> </components> </div>";

/***/ },
/* 63 */
/***/ function(module, exports) {

	module.exports = "<div> <radio-list :question=question @go-next=goNext(score)></radio-list> </div>";

/***/ },
/* 64 */
/***/ function(module, exports) {

	module.exports = "<div> <radio-list :question=question :complete=complete @go-next=goNext(score)></radio-list> </div>";

/***/ },
/* 65 */
/***/ function(module, exports) {

	module.exports = "<div> <radio-list :question=question @go-next=goNext(score)></radio-list> </div>";

/***/ },
/* 66 */
/***/ function(module, exports) {

	module.exports = "<div> <radio-list :question=question @go-next=goNext(score)></radio-list> </div>";

/***/ },
/* 67 */
/***/ function(module, exports) {

	module.exports = "<div> <radio-list :question=question @go-next=goNext(score)></radio-list> </div>";

/***/ },
/* 68 */
/***/ function(module, exports) {

	module.exports = "<div> <radio-list :question=question @go-next=goNext(score)></radio-list> </div>";

/***/ },
/* 69 */
/***/ function(module, exports) {

	module.exports = "<div> <radio-list :question=question @go-next=goNext(score)></radio-list> </div>";

/***/ },
/* 70 */
/***/ function(module, exports) {

	module.exports = "<div class=result _v-0c986214=\"\"> <div class=result-content _v-0c986214=\"\"> <a href=javascript:void(0) @click=redo class=top-link _v-0c986214=\"\">重新测试</a> <h1 class=r-title v-if=result.quota _v-0c986214=\"\">恭喜你</h1> <h1 class=r-title v-else=\"\" _v-0c986214=\"\">很遗憾</h1> <h3 class=r-subtitle v-if=result.quota _v-0c986214=\"\">可以获得 <span class=color-red _v-0c986214=\"\">{{result.quota}}</span> <span v-if=\"score<95\" _v-0c986214=\"\">万元</span>额度的信用卡</h3> <h3 class=r-subtitle v-else=\"\" _v-0c986214=\"\">您还没达到银行信用卡的办卡条件</h3> <div class=r-desc _v-0c986214=\"\">*银行会根据申请人填写的多项信息进行综合评分，给予信用卡额度，本额度仅供参考最终额度以银行为准。</div> <div class=card-img :class=result.cardImgClass _v-0c986214=\"\"></div> <div class=card-name _v-0c986214=\"\">{{result.cardName}}</div> <div class=card-desc v-html=result.cardDesc _v-0c986214=\"\"></div> <div class=btn-area _v-0c986214=\"\"> <a href=\"http://m.creditcard.com.cn/apply/action/applyForCreditCard.html?channel=0000022\" class=\"btn btn-default\" _v-0c986214=\"\">更多信用卡</a> <a :href=result.redirect class=\"btn btn-primary ml1\" _v-0c986214=\"\">立即申请</a> </div> </div> </div>";

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=hello _v-9eb86824=\"\"> <img class=cover-pic src=" + __webpack_require__(61) + " _v-9eb86824=\"\"> <h1 class=title _v-9eb86824=\"\">信用卡额度测试</h1> <h3 class=subtitle _v-9eb86824=\"\"> 高富帅 or 屌丝？<br _v-9eb86824=\"\"> 1分钟测出你的信用卡额度 </h3> <div class=start-btn @click=goTest _v-9eb86824=\"\">开始测试</div> </div>";

/***/ },
/* 72 */
/***/ function(module, exports) {

	module.exports = "<div _v-ccb4807e=\"\"> <h1 class=question _v-ccb4807e=\"\">{{ question.title }}（多选）</h1> <li class=option :class=\"{'checked':selectedItems.indexOf(item)>-1}\" v-for=\"item in question.options\" @click=select(item) _v-ccb4807e=\"\"> {{ item.text }} </li> <div class=next-btn :class=\"{'disable':selectedItems.length==0}\" @click=goNext _v-ccb4807e=\"\">下一题</div> </div>";

/***/ },
/* 73 */
/***/ function(module, exports) {

	module.exports = "<div _v-ccecde82=\"\"> <h1 class=question _v-ccecde82=\"\">{{ question.title }}（多选）</h1> <li class=option :class=\"{'checked':selectedItems.indexOf(item)>-1}\" v-for=\"item in question.options\" @click=select(item) _v-ccecde82=\"\"> {{ item.text }} </li> <div class=next-btn :class=\"{'disable':selectedItems.length==0}\" @click=goNext _v-ccecde82=\"\">下一题</div> </div>";

/***/ },
/* 74 */
/***/ function(module, exports) {

	module.exports = "<div _v-cd090d84=\"\"> <h1 class=question _v-cd090d84=\"\">{{ question.title }}（多选）</h1> <li class=option :class=\"{'checked':selectedItems.indexOf(item)>-1}\" v-for=\"item in question.options\" @click=select(item) _v-cd090d84=\"\"> {{ item.text }} </li> <div class=next-btn :class=\"{'disable':selectedItems.length==0}\" @click=goNext _v-cd090d84=\"\">下一题</div> </div>";

/***/ },
/* 75 */
/***/ function(module, exports) {

	module.exports = "<div class=content _v-f565fa20=\"\"> <h1 class=question _v-f565fa20=\"\">{{ question.title }}</h1> <li class=option :class=\"{'checked': selectedItem==item}\" v-for=\"item in question.options\" @click=select(item,$event) _v-f565fa20=\"\"> {{ item.text }} </li> <div class=next-btn :class=\"{'disable':btnDisable}\" @click=goNext _v-f565fa20=\"\"><span v-if=complete _v-f565fa20=\"\">完成</span><span v-if=!complete _v-f565fa20=\"\">下一题</span></div> </div>";

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(54)
	__vue_script__ = __webpack_require__(12)
	__vue_template__ = __webpack_require__(62)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(56)
	__vue_script__ = __webpack_require__(13)
	__vue_template__ = __webpack_require__(71)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(14)
	__vue_template__ = __webpack_require__(63)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(15)
	__vue_template__ = __webpack_require__(64)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(16)
	__vue_template__ = __webpack_require__(65)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(17)
	__vue_template__ = __webpack_require__(66)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(18)
	__vue_template__ = __webpack_require__(67)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(19)
	__vue_template__ = __webpack_require__(68)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(59)
	__vue_script__ = __webpack_require__(20)
	__vue_template__ = __webpack_require__(74)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(58)
	__vue_script__ = __webpack_require__(21)
	__vue_template__ = __webpack_require__(73)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(22)
	__vue_template__ = __webpack_require__(69)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(57)
	__vue_script__ = __webpack_require__(23)
	__vue_template__ = __webpack_require__(72)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(55)
	__vue_script__ = __webpack_require__(25)
	__vue_template__ = __webpack_require__(70)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.cbc62e7a513812ad1057.js
 **/